export const SET_PROGRESS = 'EMPLOYEE_REPORT_SET_PROGRESS'
export const RESET_PROGRESS = 'EMPLOYEE_REPORT_RESET_PROGRESS'
export const SET_SERACH_VALUE = 'SET_SERACH_VALUE'
export const LOADING = 'EMPLOYEE_REPORT_LOADING'
export const SET_SHOW_CERTIFICATE = 'SET_SHOW_CERTIFICATE'
export const SET_SHOW_FEEDBACK = 'SET_SHOW_FEEDBACK'
export const SET_HIDE_CERTIFICATE = 'SET_HIDE_CERTIFICATE'
export const SET_EMPLOYEE_STORES = 'SET_EMPLOYEE_STORES'
export const SET_EMPLOYEE_SELECTED_TAB = 'SET_EMPLOYEE_SELECTED_TAB'
export const SAVE_REASON_MESSAGE = 'SAVE_REASON_MESSAGE'
export const SET_EXEMPT_COURSES = 'SET_EXEMPT_COURSES'
export const SET_PROGRESS_FILTERED = 'SET_PROGRESS_FILTERED'
export const SET_TOGGLE_REASON_OVERLAY = 'SET_TOGGLE_REASON_OVERLAY'
export const SET_CURRENT_SELECTED_COURSE = 'SET_CURRENT_SELECTED_COURSE'
export const SET_MESSAGE = 'SET_MESSAGE'
export const SET_SUBMISSION_SHOWING = 'SET_SUBMISSION_SHOWING'
export const SET_CURRENT_SUBMISSION = 'SET_CURRENT_SUBMISSION'
export const EMPLOYEE_LIBRARY = 'EMPLOYEE_LIBRARY'
export const SET_EMPLOYEE_ID = 'SET_EMPLOYEE_ID'
export const SET_USER_MANUALLY = 'SET_USER_MANUALLY'
